import { IDLE_INTENT_STATE, type Intent, type IntentState, type InputSource } from './intent';

/** Must come before the pointer source in `CompositeInputSource` — the composite takes aim from the last source reporting, and this one always reports `IDLE_INTENT_STATE`'s zeroes (due east) if asked last. */
export class UiIntentSource implements InputSource {
  private readonly pending: Intent[] = [];

  push(intent: Intent): void {
    this.pending.push(intent);
  }

  sample(): IntentState {
    return IDLE_INTENT_STATE;
  }

  drain(): Intent[] {
    return this.pending.splice(0, this.pending.length);
  }

  dispose(): void {
    this.pending.length = 0;
  }
}
